module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/2/3-797e51a7c6b894047a715e129700f93c.jpg";